// components/HomeCalc.js

import $ from 'jquery';
import { api } from '../utils/api.js';
import { notifier } from '../utils/notifier.js';
import MicroModal from 'micromodal';
import { slideToggle } from '../utils/dom.js';

/**
 * Создает HTML-разметку для одной карточки тарифа.
 * @param {object} tariff - Объект с данными тарифа.
 * @param {string} social - Название соцсети.
 * @param {string} service - Название услуги.
 * @returns {jQuery} - jQuery объект карточки тарифа.
 */
function createTariffCard(tariff, social, service) {
    // Иконки соцсетей гарантированно лежат внутри активного шаблона.
    const iconStyle = `background-image: url('/local/templates/neolikes/assets/images/socials/${social.toLowerCase()}.svg')`;

    const $card = $(`
    <article class="calc-home__tariff-card tariff-card flex-column" data-tariff-card>
        <header class="tariff-card__header">
            <div class="tariff-card__header-block flex-column" style="${iconStyle};">
                ${tariff.NOTE ? `<div class="tariff-card__note" style="background-image: url('/local/templates/neolikes/assets/images/icons/tariff/profile.svg');">${tariff.NOTE}</div>` : ''}
                <h3 class="h3 tariff-card__title">${social} - ${tariff.NAME}</h3>
                <div class="tariff-card__benefit">${tariff.BENEFIT || ''}</div>

            </div>
            <div class="tariff-card__header-block flex-column">
                <div class="tariff-card__rating tariff-rating flex-colum">
                    <div class="tariff-rating__stars">${'★'.repeat(tariff.QUALITY_STARS || 5)}</div>
                    <span class="tariff-rating__txt">${tariff.QUALITY_TEXT || 'Высокое качество'}</span>
                </div>
                ${tariff.DESCRIPTION ? `${tariff.DESCRIPTION}` : ''}
            </div>
            <div class="tariff-card__header-block flex-column">
                <div class="tariff-card__price-order flex-column">
                    <div class="tariff-card__price">
                        <span class="tariff-card__price-num">${tariff.FINAL_RATE}<span class="tariff-card__price-currency"> ₽</span></span>
                        <span class="tariff-card__price-units">за шт.</span>
                    </div>
                    <button class="tariff-card__order tariff-card__button-state btn btn--fill" data-tariff-element-state="data-tariff-order">
                        <span class="text-one">Заказать</span>
                        <span class="text-two">Отмена</span>
                    </button>
                </div>
                <div class="tariff-card__min-max flex-column min-max">
                    <div class="min-max__row flex-align-center"><span>Мин:</span> <span>${tariff.MIN_QUANTITY}</span></div>
                    <div class="min-max__row flex-align-center"><span>Макс:</span> <span>${tariff.MAX_QUANTITY}</span></div>
                </div>
            </div>
        </header>


        <footer class="tariff-card__footer" data-tariff-order>
            <form class="tariff-card__form form flex-column">

                <label class="form__label label flex-column">
                    <span class="label__txt"><span data-placeholder-text="">${tariff.TEXT_PLACEHOLDER || 'Ссылка на профиль'}</span> <span class="label__req">*</span></span>
                    <input class="input input--icon input--icon-link url" type="text" data-order-url placeholder="${tariff.URL_PLACEHOLDER}" name="profile-link">
                </label>
                <label class="form__label label flex-column">
                    <span class="label__txt">Количество <span class="label__req">*</span></span>
                    <input class="input quantity" type="number" name="quantity" min="${tariff.MIN_QUANTITY}" max="${tariff.MAX_QUANTITY}" value="${tariff.MIN_QUANTITY}" data-order-quantity>
                </label>
                <label class="form__label label flex-column">
                    <span class="label__txt">Промокод</span>
                    <input class="input promo" type="text" name="promo-code">
                </label>
                <label class="form__label label flex-column">
                    <span class="label__txt">Комментарий</span>
                    <textarea class="textarea" data-order-comment name="comment"></textarea>
                </label>

                <div class="tabs-content__block flex-column">
                    <span class="tabs-content__result result">
                        Итог: <span class="result__number">${(tariff.FINAL_RATE * tariff.MIN_QUANTITY).toFixed(2)}</span> <span class="result__currency currency">₽</span>
                    </span>
                    <button type="submit" data-create-order class="tabs-content__btn btn btn-res">Оформить заказ</button>
                </div>
            </form>
        </footer>
    </article>
    `);

    // Сохраняем все данные тарифа в jQuery.data для легкого доступа в обработчиках
    $card.data('tariff', tariff);

    return $card;
}

/**
 * Генерирует контент для таба одной соцсети (включая табы услуг и карточки тарифов)
 * @param {string} social - Название соцсети.
 * @param {object} services - Объект с услугами для этой соцсети.
 * @param {boolean} isActive - Является ли таб активным по-умолчанию.
 * @returns {jQuery} - jQuery объект контента таба.
 */
function generateSocialTabContent(social, services, isActive = false) {
    const socialId = social.toLowerCase().replace(/\s+/g, '-');
    const $socialTabContent = $(`
        <div class="tabs__content tabs-content tabs__content--main ${isActive ? 'tabs__content--active' : ''}" data-tabs-target="${socialId}" role="tabpanel" tabindex="0">
            <div class="tabs__buttons-wrap flex-column-center">
                <div class="tabs__buttons tabs__buttons--second-level flex-align-center" data-tabs-buttons="${socialId}"></div>
            </div>
            <div class="tabs__contents tabs__contents--second-level" data-tabs-contents></div>
        </div>
    `);

    const $serviceTabsContainer = $socialTabContent.find(`[data-tabs-buttons="${socialId}"]`);
    const $serviceContentsContainer = $socialTabContent.find('.tabs__contents--second-level');

    Object.entries(services).forEach(([serviceName, tariffs], index) => {
        const isServiceActive = index === 0;
        const serviceId = `${socialId}-${serviceName.toLowerCase().replace(/\s+/g, '-')}`;
        const serviceIcon = serviceName.replaceAll(' ', '_'); // Например, "лайки", "подписчики"

        // Создаем кнопку для услуги (Лайки, Подписчики и т.д.)
        $serviceTabsContainer.append(`
            <button class="tabs__btn flex-column-center ${isServiceActive ? 'tabs__btn--active' : ''}" data-tabs-path="${serviceId}" role="tab">
                <span class="tabs__icon" style="background-image: url('/local/templates/neolikes/assets/images/all-services/${serviceIcon}.png');"></span>
                ${serviceName}
            </button>
        `);

        // Создаем контейнер для карточек тарифов этой услуги
        const $serviceContent = $(`<div class="tabs__content tabs-content ${isServiceActive ? 'tabs__content--active' : ''}" data-tabs-target="${serviceId}" role="tabpanel" tabindex="0"></div>`);

        // Генерируем и добавляем карточки тарифов
        tariffs.forEach(tariff => {
            $serviceContent.append(createTariffCard(tariff, social, serviceName));
        });

        $serviceContentsContainer.append($serviceContent);
    });

    return $socialTabContent;
}


/**
 * Главная функция для генерации всего калькулятора на главной странице.
 * @param {object} data - Полные данные из window.application.data
 */
export function generateHomeCalc(data) {
    const $calcContainer = $('[data-calc-home]');
    if (!$calcContainer.length) return;

    const $topTabsContainer = $calcContainer.find('.tabs__buttons--top-level').empty();
    const $topContentsContainer = $calcContainer.find('.tabs__contents--top-level').empty();

    Object.entries(data).forEach(([social, services], index) => {
        const isActive = index === 0;
        const socialId = social.toLowerCase().replace(/\s+/g, '-');

        // Генерируем таб для соцсети
        $topTabsContainer.append(`
            <button class="tabs__btn flex-align-center ${isActive ? 'tabs__btn--active' : ''}" data-tabs-path="${socialId}">
                <img class="tabs__icon" src="/local/templates/neolikes/assets/images/socials/${social.toLowerCase()}.svg" width="26" height="26" alt="${social}" loading="lazy" decoding="auto" aria-hidden="true">
                <span class="tabs__btn-txt">${social}</span>
            </button>
        `);
        // Генерируем контент для этой соцсети
        $topContentsContainer.append(generateSocialTabContent(social, services, isActive));
    });

    $calcContainer.removeClass('loading')
}

/**
 * Инициализирует все обработчики событий для нового калькулятора.
 */
export function initHomeCalc() {
    const $calc = $('[data-calc-home]');

    initScrollableTabCarousels($calc);

    // Логика для кнопок "Показать описание" и "Заказать" / "Отмена"
    $calc.on('click', '[data-tariff-element-state]', function() {
        const $this = $(this);
        const $card = $this.closest('.tariff-card');
        const stateTargetSelector = $this.data('tariff-element-state');
        const $targetElement = $card.find(`[${stateTargetSelector}]`);

        $card.toggleClass(`is-active--${stateTargetSelector}`);
        slideToggle($targetElement[0], 300);
    });

    // Обновление итоговой суммы при изменении количества
    $calc.on('input', '.quantity', function() {
        const $input = $(this);
        const $card = $input.closest('.tariff-card');
        const tariff = $card.data('tariff');

        const min = parseInt($input.attr('min'), 10);
        const max = parseInt($input.attr('max'), 10);
        let quantity = parseInt($input.val(), 10) || 0;

        if (quantity > max) {
            quantity = max;
            $input.val(max);
        }
        // Не позволяем вводить значение меньше минимального, но позволяем стереть поле
        if (quantity < min && $input.val() !== '') {
            quantity = min;
            $input.val(min);
        }


        const total = tariff.FINAL_RATE * quantity;
        $card.find('.result__number').text(total.toFixed(2));
    });

    // Обработка отправки формы заказа
    $calc.on('submit', '.tariff-card__form', async function(e) {
        e.preventDefault();
        const $form = $(this);
        const $card = $form.closest('.tariff-card');
        const tariff = $card.data('tariff');

        const link = $form.find('[data-order-url]').val().trim();
        const quantity = parseInt($form.find('[data-order-quantity]').val(), 10);
        const comment = $form.find('[data-order-comment]').val().trim();

        const total = parseFloat($card.find('.result__number').text());

        if (!link) {
            return notifier.alert('Введите ссылку на профиль.');
        }
        if (!quantity || quantity < tariff.MIN_QUANTITY) {
            return notifier.alert(`Минимальное количество для заказа: ${tariff.MIN_QUANTITY}.`);
        }
        if (total < 1) {
            return notifier.alert('Сумма заказа не может быть меньше 1 рубля.');
        }


        const orderData = {
            serviceId: tariff.SERVICE_ID,
            link,
            quantity,
            comment
        };

        try {
            if (application.isAuthorized) {
                const response = await api.post('/api/createOrder', orderData);
                if (response.result && response.payment_url) {
                    window.location.href = response.payment_url;
                }
            } else {
                notifier.confirm('Хотите создать заказ анонимно (без регистрации)?',
                    async function() { // onOk
                        const response = await api.post('/api/createOrder', orderData);
                        if (response.result && response.payment_url) {
                            window.location.href = response.payment_url;
                        }
                    },
                    function() { // onCancel
                        MicroModal.show('modal-register');
                    },
                    { labels: { confirm: '', confirmOk: 'Да', confirmCancel: 'Нет' } }
                );
            }
        } catch (error) {
            console.error('Order creation error:', error.response?.status, error.response?.data, error);
            notifier.alert('Ошибка сервера. Попробуйте позже.');
        }
    });

    // Basic tabs logic (from your dom.js)
    // This relies on the vanilla JS implementation you already have.
    // Ensure your data-attributes are set up correctly.
    $(document).on('click', '[data-tabs-parent] [data-tabs-path]', function (e) {
        const parentTabsComponent = e.target.closest('[data-tabs-parent]');
        const tabsPath = e.target.closest('[data-tabs-path]').dataset.tabsPath;
        const parentBtns = e.target.closest('[data-tabs-buttons]');

        // Deactivate sibling buttons
        parentBtns?.querySelectorAll('[data-tabs-path]').forEach(btn => btn.classList.remove('tabs__btn--active'));
        e.target.closest('[data-tabs-path]').classList.add('tabs__btn--active');

        // Find contents within the same parent tab component
        const contentsWrapper = parentTabsComponent.querySelector(`[data-tabs-target="${tabsPath}"]`)?.parentElement;
        if (contentsWrapper) {
            // Deactivate sibling content panes
            contentsWrapper.querySelectorAll(':scope > [data-tabs-target]').forEach(content => content.classList.remove('tabs__content--active'));

            // Activate target content pane
            const targetContent = contentsWrapper.querySelector(`[data-tabs-target="${tabsPath}"]`);
            targetContent?.classList.add('tabs__content--active');
        }
    });

}

/**
 * Добавляет явное управление горизонтальными списками соцсетей и услуг.
 */
function initScrollableTabCarousels($calc) {
    const updateControls = ($wrap) => {
        const viewport = $wrap.find('.tabs-carousel__viewport')[0];
        if (!viewport) return;

        const hasOverflow = viewport.scrollWidth - viewport.clientWidth > 2;
        const atStart = viewport.scrollLeft <= 2;
        const atEnd = viewport.scrollLeft + viewport.clientWidth >= viewport.scrollWidth - 2;

        $wrap.toggleClass('is-scrollable', hasOverflow);
        $wrap.find('[data-tabs-carousel-prev]').prop('disabled', !hasOverflow || atStart);
        $wrap.find('[data-tabs-carousel-next]').prop('disabled', !hasOverflow || atEnd);
    };

    const updateAll = () => {
        $calc.find('.tabs__buttons-wrap.tabs-carousel').each(function () {
            updateControls($(this));
        });
    };

    $calc.find('.tabs__buttons-wrap').each(function () {
        const $wrap = $(this);
        if ($wrap.hasClass('tabs-carousel')) return;

        const $buttons = $wrap.children('.tabs__buttons');
        if (!$buttons.length) return;

        $buttons.wrap('<div class="tabs-carousel__viewport"></div>');
        $wrap
            .addClass('tabs-carousel')
            .prepend('<button type="button" class="tabs-carousel__control btn-res" data-tabs-carousel-prev aria-label="Прокрутить список влево">&#8249;</button>')
            .append('<button type="button" class="tabs-carousel__control btn-res" data-tabs-carousel-next aria-label="Прокрутить список вправо">&#8250;</button>');

        const $viewport = $wrap.find('.tabs-carousel__viewport');
        $viewport.on('scroll', () => updateControls($wrap));
    });

    $calc.on('click', '[data-tabs-carousel-prev], [data-tabs-carousel-next]', function () {
        const $control = $(this);
        const $wrap = $control.closest('.tabs-carousel');
        const viewport = $wrap.find('.tabs-carousel__viewport')[0];
        if (!viewport) return;

        const direction = $control.is('[data-tabs-carousel-prev]') ? -1 : 1;
        viewport.scrollBy({ left: direction * viewport.clientWidth * 0.75, behavior: 'smooth' });
    });

    $calc.on('click', '[data-tabs-path]', () => requestAnimationFrame(updateAll));
    $(window).on('resize', updateAll);
    requestAnimationFrame(updateAll);
}
